import { createAsyncThunk, createSlice } from "@reduxjs/toolkit";
import axios from "axios";
import { baseUrl } from "../index";
import { getAuthToken } from "../../utils/utils";

export const fetchSystemYears = createAsyncThunk(
  "yearManagement/fetchYears",
  async (_, { rejectWithValue }) => {
    try {
      const token = getAuthToken();
      const response = await axios.get(`${baseUrl}/admin/years`, {
        headers: { Authorization: token },
      });
      return response.data.years;
    } catch (error) {
      return rejectWithValue(error.response?.data?.message || "Failed to fetch years");
    }
  }
);

export const addYearToAllUsers = createAsyncThunk(
  "yearManagement/addYear",
  async (year, { rejectWithValue }) => {
    try {
      const token = getAuthToken();
      const response = await axios.post(
        `${baseUrl}/admin/years/add`,
        { year },
        { headers: { Authorization: token } }
      );
      return response.data;
    } catch (error) {
      return rejectWithValue(error.response?.data?.message || "Failed to add year");
    }
  }
);

export const removeYearFromAllUsers = createAsyncThunk(
  "yearManagement/removeYear",
  async (year, { rejectWithValue }) => {
    try {
      const token = getAuthToken();
      const response = await axios.post(
        `${baseUrl}/admin/years/remove`,
        { year },
        { headers: { Authorization: token } }
      );
      return { ...response.data, removedYear: year };
    } catch (error) {
      return rejectWithValue(error.response?.data?.message || "Failed to remove year");
    }
  }
);

const yearManagementSlice = createSlice({
  name: "yearManagement",
  initialState: {
    years: [],
    loading: false,
    actionLoading: false,
    error: null,
    successMessage: null,
  },
  reducers: {
    clearMessages(state) {
      state.error = null;
      state.successMessage = null;
    },
  },
  extraReducers: (builder) => {
    builder
      .addCase(fetchSystemYears.pending, (state) => {
        state.loading = true;
        state.error = null;
      })
      .addCase(fetchSystemYears.fulfilled, (state, action) => {
        state.loading = false;
        state.years = action.payload;
      })
      .addCase(fetchSystemYears.rejected, (state, action) => {
        state.loading = false;
        state.error = action.payload;
      })

      .addCase(addYearToAllUsers.pending, (state) => {
        state.actionLoading = true;
        state.error = null;
        state.successMessage = null;
      })
      .addCase(addYearToAllUsers.fulfilled, (state, action) => {
        state.actionLoading = false;
        state.successMessage = action.payload.message;
        const year = Number(action.meta.arg);
        if (!state.years.includes(year)) {
          state.years = [...state.years, year].sort((a, b) => a - b);
        }
      })
      .addCase(addYearToAllUsers.rejected, (state, action) => {
        state.actionLoading = false;
        state.error = action.payload;
      })

      .addCase(removeYearFromAllUsers.pending, (state) => {
        state.actionLoading = true;
        state.error = null;
        state.successMessage = null;
      })
      .addCase(removeYearFromAllUsers.fulfilled, (state, action) => {
        state.actionLoading = false;
        state.successMessage = action.payload.message;
        state.years = state.years.filter((y) => y !== Number(action.payload.removedYear));
      })
      .addCase(removeYearFromAllUsers.rejected, (state, action) => {
        state.actionLoading = false;
        state.error = action.payload;
      });
  },
});

export const { clearMessages } = yearManagementSlice.actions;
export default yearManagementSlice.reducer;
